import { storedAttributeProps } from "../html-attributes";
import { Button } from "@react-email/components";
import type { ButtonAttrs } from "./definition";
import { getButtonStyles, getButtonWrapperStyles } from "./styles";
export function buttonEmailRenderer(attrs: ButtonAttrs) {
  const wrapperStyles = getButtonWrapperStyles(attrs.alignment);
  const buttonStyles = getButtonStyles(attrs);
  return <div style={wrapperStyles}>
      <Button href={attrs.href || "#"} {...storedAttributeProps(attrs)} style={buttonStyles}>
        {attrs.text || "Click here"}
      </Button>
    </div>;
}